<script>
    import Button, { Label } from '@smui/button';
    import Card from '@smui/card';
    import ContactFooter from "../common/contact/ContactFooter.svelte";
</script>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-7">
                <Card>
                    <div class="cng-card__primary">
                        <div class="mdc-typography--headline5">We-ID Enterprise oplossing</div>
                    </div>
                    <div class="cng-card__divider"></div>
                    <div class="cng-card__secondary">
                        <div style="width: 100%; text-align: justify">
                            <p>
                                eHerkenning voor meerdere KvK-nummers
                                <br>
                                <br>
                                Met de We-ID Enterprise oplossing koppelt u eenvoudig eHerkenningsmiddelen van meerdere gebruikers aan één of meerdere KvK-nummers. Zo houdt u grip en overzicht binnen uw organisatie.
                                <br>
                                <br>
                                Deze aanvraag is bedoeld voor het aanmelden van nieuwe bedrijven of personen. Wilt u wijzigingen doorvoeren of bestaande eHerkenningsmiddelen uitbreiden? Log dan in op de <a href="https://ehlogin.we-id.nl/beheer">We-ID Beheermodule</a>.
                                <br>
                                <br>
                                Als nieuwe gebruiker krijgt u, na activatie door de beheerders (met minimaal EH2+), toegang tot de We-ID Beheermodule. Met de Beheermodule regelt u alles rondom machtigingen snel, overzichtelijk en volledig online - van toevoegen en wijzigen tot beëindigen, activeren en verlengen.
                                <br>
                                <br>
                                <b>LET OP:</b>
                                <br>
                                Per KvK-nummer is minimaal één beheerder vereist met een eHerkenningsmiddel op betrouwbaarheidsniveau EH2+. 
                            </p>
                        </div>
                        <div><Button on:click={() => window.location.href="#/registration"} variant="raised"><Label>Start aanvraag</Label></Button></div>
                    </div>
                    <ContactFooter/>
                </Card>
            </div>
        </div>
    </div>
